export function fixDocbookUrl (url) {
    if (typeof window === 'undefined') return url
    const ROOTS = ['docbook.cn', 'docbook.com.cn']
    const currentRoot = ROOTS.find(r =>
        window.location.hostname === r || window.location.hostname.endsWith('.' + r)
    )
    if (!currentRoot) return url
    try {
        const u = new URL(url, window.location.href)
        for (const root of ROOTS) {
            if (u.hostname === root || u.hostname.endsWith('.' + root)) {
                const sub = u.hostname === root ? '' : u.hostname.slice(0, -root.length - 1)
                u.hostname = sub ? `${sub}.${currentRoot}` : currentRoot
                return u.href
            }
        }
        return url
    } catch {
        return url
    }
}